export default {
  news: 2,
  products: 2,
  helpers: 1
}
